import { useMutation } from '@tanstack/react-query';
import { Col, Divider, Form, Row } from 'antd';
import { CalculationSetupApis } from 'apis/CalculationSetupApis';
import { FormFilter, InputForm, SelectForm } from 'components';
import LazySelectForm, {
  ILazySelectData,
  ILazySelectParams,
  initLazySelectData,
} from 'components/Select/LazySelectForm';
import Content from 'layouts/Content';
import { useEffect, useState } from 'react';
import { typeRewardOptions } from 'utils/constants/constant';

const spanCol = 8;

interface FilterRewardConditionProps {
  isOpen: boolean;
  onFinish: (values: any) => void;
  onCancel: () => void;
}

const FilterRewardCondition = ({
  isOpen,
  onFinish,
  onCancel,
}: FilterRewardConditionProps) => {
  const [form] = Form.useForm();
  const [rewardData, setRewardData] =
    useState<ILazySelectData>(initLazySelectData);

  const {
    mutate: getComboboxGroupRoleManagement,
    isPending: isPendingGetComboboxGroupRoleManagement,
  } = useMutation({
    mutationFn: CalculationSetupApis.getComboboxGroupRoleManagement,
    onSuccess: (data) => {
      const rewardIds: string[] = [];
      const options = (data?.data?.getGroupRoleManagement?.items ?? [])
        .filter((item: any) => {
          if (rewardIds.includes(item.rewardId)) return false;
          rewardIds.push(item.rewardId);
          return true;
        })
        .map((item: any) => ({
          ...item,
          id: item.rewardId,
          label: item.rewardId,
          value: item.rewardId,
        }));

      setRewardData({
        options,
        totalItems: data?.data?.getGroupRoleManagement?.pageInfo?.totalItems,
        hasNextPage: data?.data?.getGroupRoleManagement?.pageInfo?.hasNextPage,
      });
    },
  });

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleRewardScrollChange = (value: ILazySelectParams) => {
    getComboboxGroupRoleManagement({
      skip: 0,
      take: value.pageSize,
      rewardId: value.value,
    });
  };

  useEffect(() => {
    getComboboxGroupRoleManagement({
      skip: 0,
      take: 100,
    });
  }, [getComboboxGroupRoleManagement]);

  return (
    <>
      <Content isOpen={isOpen}>
        <FormFilter form={form} onFinish={onFinish} onCancel={handleCancel}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={spanCol} className="h-[80px]">
              <Form.Item label="Mã điều kiện" name="id">
                <InputForm placeholder="Nhập mã điều kiện" />
              </Form.Item>
            </Col>
            <Col span={spanCol} className="h-[80px]">
              <Form.Item label="Mã thưởng DMS" name="groupRoleManagement">
                <LazySelectForm
                  hasNextPage={rewardData.hasNextPage}
                  customeSize={20}
                  allowClear
                  data={rewardData}
                  placeholder="Chọn mã dự thưởng"
                  loading={isPendingGetComboboxGroupRoleManagement}
                  onSelectScrollChange={handleRewardScrollChange}
                  showSearch
                  // disabled={!rewardData.options.length}
                />
              </Form.Item>
            </Col>
            <Col span={spanCol} className="h-[80px]">
              <Form.Item label="Loại" name="typeReward">
                <SelectForm
                  options={typeRewardOptions}
                  placeholder="Chọn loại"
                />
              </Form.Item>
            </Col>
          </Row>
        </FormFilter>
      </Content>
      <Divider />
    </>
  );
};

export default FilterRewardCondition;
